import React, { createContext, useContext, useState, ReactNode } from 'react';
interface OrderContextType {
  orderId: number | null;
  setOrderId: (id: number) => void;
  selectedPayment: number | null;
  setSelectedPayment: (id: number) => void;
  selectedDelivery: number | null;
  setSelectedDelivery: (id: number) => void;
  selectedAddressId: number | null;
  setSelectedAddressId: (id: number | null) => void;
}
const OrderContext = createContext<OrderContextType | undefined>(undefined);
export const OrderProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [orderId, _setOrderId] = useState<number | null>(null);
  const [selectedPayment, _setSelectedPayment] = useState<number | null>(null);
  const [selectedDelivery, _setSelectedDelivery] = useState<number | null>(null);
  const [selectedAddressId, _setSelectedAddressId] = useState<number | null>(null);
  const setOrderId = (id: number) => {
    _setOrderId(id);
    if (typeof window !== 'undefined') {
      localStorage.setItem('orderId', String(id));
    }
  };
  const setSelectedPayment = (id: number) => {
    _setSelectedPayment(id);
    if (typeof window !== 'undefined') {
      localStorage.setItem('selectedPayment', String(id));
    }
  };
  const setSelectedDelivery = (id: number) => {
    _setSelectedDelivery(id);
    if (typeof window !== 'undefined') {
      localStorage.setItem('selectedDelivery', String(id));
    }
  };
  const setSelectedAddressId = (id: number | null) => {
    _setSelectedAddressId(id);
    if (typeof window !== 'undefined') {
      if (id !== null) {
        localStorage.setItem('selectedAddressId', String(id));
      } else {
        localStorage.removeItem('selectedAddressId');
      }
    }
  };
  return <OrderContext.Provider value={{
    orderId,
    setOrderId,
    selectedPayment,
    setSelectedPayment,
    selectedDelivery,
    setSelectedDelivery,
    selectedAddressId,
    setSelectedAddressId
  }} data-sentry-element="unknown" data-sentry-component="OrderProvider" data-sentry-source-file="order-context.tsx">
      {children}
    </OrderContext.Provider>;
};
export const useOrderContext = (fallback?: boolean) => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error('useOrderContext must be used within an OrderProvider');
  }
  if (fallback && typeof window !== 'undefined') {
    if (context.orderId === null) {
      const storedOrderId = localStorage.getItem('orderId');
      if (storedOrderId) {
        context.setOrderId(Number(storedOrderId));
      }
    }
    if (context.selectedPayment === null) {
      const storedPayment = localStorage.getItem('selectedPayment');
      if (storedPayment) {
        context.setSelectedPayment(Number(storedPayment));
      }
    }
    if (context.selectedDelivery === null) {
      const storedDelivery = localStorage.getItem('selectedDelivery');
      if (storedDelivery) {
        context.setSelectedDelivery(Number(storedDelivery));
      }
    }
    if (context.selectedAddressId === null) {
      const storedAddress = localStorage.getItem('selectedAddressId');
      if (storedAddress) {
        context.setSelectedAddressId(Number(storedAddress));
      }
    }
  }
  return context;
};